import { Grid, makeStyles } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { ToolBar } from "../../../../modules/home/ToolBar";
import { RequestFeedbackDetailsLayoutProp } from "../../../../modules/user/request_feedback/typeRequestFeedback";
import { State } from "../../../../type";
import { HomeLayout } from "../../../home/Layout";

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: "left",
    padding: theme.spacing(6, 6, 6, 5),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(5, 4, 4, 4),
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(10),
      padding: theme.spacing(5.5, 3, 3, 3),
    },
    marginTop: theme.spacing(9),
    background: "#F5F6FA",
    height: "-webkit-fill-available",
    minHeight: `${window.innerHeight - 102}px`,
  },
}));

export const RequestFeedbackDetailsLayout: React.FC<RequestFeedbackDetailsLayoutProp> =
  ({
    props,
    setLogout,
    isDetailView,
    setIsDetailView,
    renderErrorModal,
    renderDetails,
  }) => {
    const classes = useStyle();
    window.scrollTo(0,0);
    document.title = "Grow-Wize | Request Feedback Detail";
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
    };
    const tempFunction = () => {
      return 0;
    };

    const renderToolBar = () => (
      <ToolBar
        headerName="Request Feedback Detail"
        setLogout={setLogout}
        isDetailView={isDetailView}
        setIsDetailView={setIsDetailView}
        handleDrawerToggle={handleDrawerToggle}
        value={-2}
        setValue={tempFunction}
        tabValue={-2}
        validLength={false}
      ></ToolBar>
    );

    const renderFeedbackRequestDetailLayout = () => (
      <Grid
        container
        spacing={1}
        direction="column"
        className={classes.root}
        justify="flex-start"
        alignItems="flex-start"
      >
        <Grid container alignItems="stretch" direction="column">
          {renderErrorModal()}
          {renderDetails()}
        </Grid>
      </Grid>
    );
    const loading: boolean = useSelector(
      (state: State) => state.sentRequestDetails.loading
    );

    return (
      <HomeLayout
        loading={loading}
        renderToolBar={renderToolBar}
        props={props}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        renderSelectedOption={renderFeedbackRequestDetailLayout}
      ></HomeLayout>
    );
  };
